<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <!-- <el-input size="medium" v-model="searchForm.key_words" placeholder="请输入搜索内容"  @keyup.enter.native="getTableList"></el-input> -->
      <el-date-picker
       size="medium"
        v-model="searchForm.startTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
        placeholder="请选择开始时间">
      </el-date-picker>
      <el-date-picker
        size="medium"
        v-model="searchForm.endTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        placeholder="请选择结束时间">
      </el-date-picker>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
      <a :href="url+'/netPowerDaily/export?startTime='+searchForm.startTime + '&&endTime='+searchForm.endTime" style="margin-left:20px">
         <el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
      </a>
      <!-- <el-button size="medium" type="warning" icon="el-icon-folder-opened" @click="getDerive">导出</el-button> -->
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      width="110px"
      prop="date"
      label="时间">
    </el-table-column>
    <el-table-column
      width="140px"
      prop="network_storage_power"
      label="全网有效算力(Eib)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.networkStoragePower,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="activeMiners"
      width="120px"
      label="活跃矿工数(个)">
    </el-table-column>
    <el-table-column
      prop="blockReward"
      width="130px"
      label="每区块奖励(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.blockReward,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="averageMiningReward"
      width="200px"
      label="24h平均挖矿收益(FIL/TiB)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.averageMiningReward,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="filProduction"
      width="140px"
      label="近24h产出量(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.filProduction,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      width="200px"
      prop="currentSectorInitialPledge"
      label="当前扇区质押量(FIL/32GiB)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.currentSectorInitialPledge,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="totalPledgeCollateral"
      width="120px"
      label="FIL质押量(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.totalPledgeCollateral,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="messages"
      width="120px"
      label="24h消息数(个)">
    </el-table-column>
    <el-table-column
      prop="circulatingSupply"
      width="120px"
      label="FIL流通量(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.circulatingSupply,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="totalAccounts"
      width="110px"
      label="总帐户数(个)">
    </el-table-column>
    <el-table-column
      prop="costSealingSectors"
      width="170px"
      label="新增算力成本(FIL/TiB)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.costSealingSectors,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="currentBaseFee"
      width="180px"
      label="当前基础费率(nanoFIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.currentBaseFee,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="burntFil"
      width="120px"
      label="FIL销毁量(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.burntFil,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="circulatingRate"
      width="130px"
      label="FIL流通率(%)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.circulatingRate,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="createTime"
      width="160px"
      label="创建时间">
      <!-- <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.costSealingSectors,4)}}</span>
      </template> -->
    </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        startTime:'',
        endTime:'',
      },
      tableData: [],
      url: window.g.host
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    async getDerive(){
      let data = {
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime
      }
      let res = await this.$http.netPowerExport({...data});
      if (res) {
        console.log(res)
      }
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.netPowerDaily({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
